import React from 'react';
import WorkbookBadge from '../Badges/WorkbookBadge';
import maybe from '../@common/enhancers/maybe';
import { BadgeType } from 'types';
import ArrowIcon from 'assets/icons/ArrowIcon';
import { remCalc } from '../../util/style-util';
import { FONT_GSS_FUTURA } from 'themes/default';
import { makeStyles } from '@mui/styles';

type Props = {
  title: string;
  imageUrl: string;
  openWorkbookMenu: () => void;
  renderWorkbookBadge: boolean;
  badgeType: BadgeType;
  gradeLevelDescription: string;
  shouldHaveArrow: boolean;
};

const MaybeWorkbookBadge = maybe(WorkbookBadge) as any;

const WorkbookSelector = ({
  title,
  imageUrl,
  openWorkbookMenu,
  renderWorkbookBadge,
  badgeType,
  gradeLevelDescription,
  shouldHaveArrow
}: Props) => {
  const classes = useStyles()({ shouldHaveArrow });
  return (
    <div className={classes.workbookSelector} onClick={openWorkbookMenu}>
      <img
        className={classes.selectorIcon}
        src={imageUrl}
        alt="Combined Workbook and Teacher-Guide Icon"
      />
      <MaybeWorkbookBadge
        shouldRender={renderWorkbookBadge}
        badgeType={badgeType}
        styles={classes.badge}
      />
      <span className={classes.selectorGrade}>
        {title}
        {shouldHaveArrow && (
          <div className={classes.selectorGradeArrow}>
            <ArrowIcon />
          </div>
        )}
        <div className={classes.gradeLevelDescription}>{gradeLevelDescription}</div>
      </span>
    </div>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    workbookSelector: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: remCalc(200),
      borderBottom: '1px solid #4d4d4d',
      paddingRight: '4px',
      position: 'relative'
    },
    selectorIcon: ({ shouldHaveArrow }: any) => ({
      cursor: shouldHaveArrow ? 'pointer' : 'auto',
      width: '60%'
    }),
    selectorGrade: ({ shouldHaveArrow }: any) => ({
      fontFamily: FONT_GSS_FUTURA,
      fontWeight: 300,
      fontSize: remCalc(14),
      padding: `${remCalc(2)} ${remCalc(20)}`,
      borderRadius: '15px',
      backgroundColor: 'rgba(20, 20, 20, 0.4)',
      marginTop: remCalc(10),
      textAlign: 'center',
      cursor: shouldHaveArrow ? 'pointer' : 'auto'
    }),
    selectorGradeArrow: {
      width: remCalc(5),
      display: 'inline-block',
      transform: 'rotate(270deg)',
      position: 'relative',
      left: remCalc(10),
      top: remCalc(1)
    },
    gradeLevelDescription: {
      fontSize: remCalc(12)
    },
    badge: {
      bottom: remCalc(85),
      right: remCalc(35)
    }
  }));

export default WorkbookSelector;
